import React from 'react';
import SlIconButton from "@shoelace-style/shoelace/dist/react/icon-button";
import SlTooltip from "@shoelace-style/shoelace/dist/react/tooltip";
import './DismissibleCard.css';

type ThemeType = 'success' | 'error' | 'info' | 'default';

interface DismissibleCardProps {
  children: React.ReactNode;
  onDismiss: () => void;
  title?: string;
  className?: string;
  theme?: ThemeType;
}

export const DismissibleCard: React.FC<DismissibleCardProps> = ({
  children,
  onDismiss,
  title,
  className = "",
  theme = "default"
}) => {
  const getThemeClass = () => {
    if (theme === 'default') return '';
    return `dismissible-card-theme-${theme}`;
  };

  return (
    <div className={`bg-white p-6 rounded-lg border-2 border-cardBorder relative ${getThemeClass()} ${className}`}>
      {/* Botón de cerrar */}
      <div className="absolute top-2 right-2">
        <SlTooltip content="Cerrar">
          <SlIconButton
            name="x-lg"
            onClick={onDismiss}
            className="dismissible-card-icon"
          />
        </SlTooltip>
      </div>

      {/* Título opcional */}
      {title && (
        <h4 className={`font-semibold mb-3 text-[16px] pr-8 dismissible-card-title ${theme === 'default' ? 'text-textSecondary' : ''}`}>
          {title}
        </h4>
      )}

      {/* Contenido */}
      <div className={title ? "" : "pt-4"}>
        {children}
      </div>
    </div>
  );
};